import React, { useState, useEffect, useContext } from "react"
import styled from "styled-components"
import { FaCheck } from "@react-icons/all-files/fa/FaCheck"
import { FaLock } from "@react-icons/all-files/fa/FaLock"
// import * as lookup from "../../../../static/lookup.json"
import * as lookup from "../../../../static/lookup.json"
import { SectionContext } from "../../context/sectionContext"
import { ConditionContext } from "../../context/conditionContext"
import { PageContext } from "../../context/pageContext"
import { JourneyContext } from "../../context/journeyContext"
import { ErrorContext } from "../../context/errorContext"
import DocListPDF from "../../../documents/List-of-acceptable-documents.pdf"
import {
  generateBI,
  fetchAllJourneyData,
  pdfDownload,
  uploadDocument,
  saveApplication,
  fetchApplicationDetails,
  sendEmailBI,
  s3uploadPdfBI,
  whatsAppOptin,
  getTOFpaymentReceipt,
  saveTransactionDetails,
  updateUserTrackerDetails
} from "../../../services/apiservice"
import {
  getDateInFormat,
  getStateFromCode,
  getAge,
  findCurrentJourneyCode,
  getValueFromLookup,
  findRiderSA,
  findRiderSAPercent,
  getSourceFromChannel,
  transformReceiptToTransaction
} from "../../services/helperFunctions"
import {
  errorToastr,
  successToastr,
  clearToastr,
} from "../../../services/error-handler"
import { wordCapital, lineCapital, applyComma, maskInFormat, calculateAge } from '../../../shared/functions'
import ContactConsentModal from "../../common/ContactConsentModal"
import useBiContactConsentGate from "../../common/useBiContactConsentGate"
import {
  CONTACT_CONSENT_CONFIG,
  getContactConsentFromJourneyData,
  hasFieldValue,
} from "../../services/contactConsentPolicy"
const moment = require('moment')
export default function BIPension4Life(props) {
  let [isactive, setIsActive] = useState(true)
  const [sectionState, setSectionState] = useContext(SectionContext)
  const [pageState, setPageState] = useContext(PageContext)
  const [journeyState, setJourneyState] = useContext(JourneyContext)
  const [conditionState, setConditionState] = useContext(ConditionContext)
  const [errorState, setErrorState] = useContext(ErrorContext);
  const [allJourneyData, setAllJourneyData] = useState()
  const [biApiData, setBiApiData] = useState()
  const [payNowOrLater, setPayNowOrLater] = useState("later")
  const [pdfData, setPdfData] = useState("")
  const [agreeToDeclaration, setAgreeToDeclaration] = useState(false)
  const [proceedWithOption, setProceedWithOption] = useState()
  const [location, setLocation] = useState()
  const [isChecked, setIsChecked] = useState(true)
  const [skipPayment, setSkipPayment] = useState(false) ;
  const [isPayBasba, setIsPayBasba] = useState(false)
  const canSendBiEmail = hasFieldValue(
    getContactConsentFromJourneyData(journeyState?.journeyData).email
  )
  const disabledEmailButtonStyle = canSendBiEmail
    ? {}
    : {
        cursor: "not-allowed",
        backgroundColor: "#f4f4f4",
        border: "1px solid #d6d6d6",
        opacity: 0.7,
      }
  const emailAnchorStyle = {
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
    color: canSendBiEmail ? undefined : "#7a7a7a",
  }

  const contactConsentGate = useBiContactConsentGate({
    journeyState,
    setJourneyState,
    setConditionState,
    saveApplication,
    config: CONTACT_CONSENT_CONFIG,
    buildSavePayload: updatedJourneyData => ({
      applicationData: updatedJourneyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
        journeyIdFromStrapi: journeyState.journeyIdFromStrapi,
        channel: journeyState.channel,
      },
    }),
  })
  console.log(allJourneyData?.productDetails?.planOption)

  //container
  const RadioContainer = styled.div`
    width: 100%;
    display: block;
    flex-direction: column;
    margin: 15px 0;
    position: relative;
    box-sizing: border-box;
    font-size: 15px;
    color: #505050;
    float: left;

    & > label {
      margin-left: 8px;
      margin-bottom: 5px;
      color: #505050;
      font-size: 16px;
      background-color: #fff;
      padding: 2px 5px;
      z-index: 999;
      position: relative;
      display: inline-block;
      cursor: default;
      max-width: 100%;
      & > .radio-label {
        text-align: center;
      }
    }

    .card {
      width: 100%;
      border-radius: 1rem;
      padding: 1rem 0;
      border-radius: 15px;
      background-color: #fff;
      position: relative;
      margin: 0px;
      margin-bottom: 0px;
      cursor: pointer;
      height: 9rem;
      margin-top: 0px;
      box-shadow: 0px 0px 20px #ccc;
      transition: all 200ms;

      .amount {
        color: black;
        margin-bottom: 2rem;
        margin-left: 6.5rem;
        border-left: 1px solid #ccc;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ededed;
        color: black;
        text-align: center;
        padding-right: 34px;
      }
    }

    /*Check tick start  */
    .checked {
      background: #ededed;
      color: #ededed;
      position: absolute;
      left: 2rem;
      top: 1rem;
      height: 2.5rem;
      width: 2.5rem;
      border-radius: 50%;
      padding: 8px;
      & > * {
        font-size: 1.2rem;
      }
    }

    input:checked ~ .card .checked {
      background: #fff;
      color: ${props =>
        props.channel === "A"
          ? "#3e505d"
          : props.channel === "B"
          ? "#a20a3a"
          : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
      color: var(--lumiq-card-bg);
    }
    /*Check tick end */

    .icon-container {
      font-size: 3rem;
      padding: 1rem;
      span {
        border-radius: 50%;
        padding: 1rem;

        background: #3e505d;
        .hero-icon {
          padding-top: 8px;
          color: #fff;
        }
      }
    }

    input:checked ~ .card {
      background-color: ${props =>
        props.channel === "A"
          ? "#3e505d"
          : props.channel === "B"
          ? "#a20a3a"
          : props.channel === "C"
          ? "#0ab0ef"
          : "#eb7f25"};
      background-color: var(--lumiq-card-bg);
      color: #fff;
      .icon-container-1 {
        span {
          background: #fff;
          .hero-icon {
            color: #3e505d;
          }
        }
      }

      .amount {
        color: white;
        margin-bottom: 2rem;
        margin-left: 6.5rem;
        border-left: 1px solid #ccc;
        padding-left: 1.5rem;
        height: 3rem;
        font-size: 21px;
      }
      .desc {
        padding: 0.8rem;
        background: #ffffff;
        color:black
        text-align: center;
        padding-right: 34px;
      }
    }

    input:not(:checked) ~ .card {
      /* opacity: 0.5; */
      .amount {
        color: #818181;
      }

      .desc {
        color: #3e505d;
      }
    }
  `
  async function downloadLinkOfPdf(Base64Pdf) {
    // if(!location){
    //   const result = await s3uploadPdfBI({applicationNumber: journeyState.applicationNo,
    //     Base64Pdf: Base64Pdf,
    //   })
    //   setLocation(result.data.location)
    //   window.open(result.data.location,"_self");
    // }else{
    //   window.open(location,"_self");
    // }
    const fileName = `${lookup?.pdfProdutPlanName[journeyState?.journeyIdFromStrapi] ?? ""}_${journeyState.applicationNo}.pdf`
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      var byteCharacters = atob(Base64Pdf)
      var byteNumbers = new Array(byteCharacters.length)
      for (var i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i)
      }
      var byteArray = new Uint8Array(byteNumbers)
      var blob = new Blob([byteArray], { type: "application/pdf" })
      window.navigator.msSaveOrOpenBlob(blob, fileName)
      return
    }
    // For Other Browsers
    const linkSource = "data:application/pdf;base64," + Base64Pdf
    const link = document.createElement("a")
    link.href = linkSource
    link.download = fileName
    document.body.appendChild(link)
    link.click()
    link.remove()

    window.addEventListener(
      "focus",
      function () {
        URL.revokeObjectURL(link.href)
      },
      { once: true }
    )
  }

  const handleOnChange = () => {
    setIsChecked(!isChecked);
  };

  const downloadPdf = async () => {
    let sendEmailPdfData = pdfData
    if (!sendEmailPdfData) {
      if (!biApiData) {
        return
      } else {
        let pdfResult = await pdfDownload({
          applicationNumber: journeyState.applicationNo,
          TID: biApiData?.TransactionId || "",
        })
        setPdfData(pdfResult.data.Base64Pdf)
        sendEmailPdfData = pdfResult.data.Base64Pdf
      }
    }
    downloadLinkOfPdf(sendEmailPdfData)
  }

  const printPdf = async () => {
    if (pdfData) {
      printPdf1(pdfData)
    } else {
      let pdfResult = await pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: biApiData?.TransactionId || "",
      })
      setPdfData(pdfResult.data.Base64Pdf)
      printPdf1(pdfResult?.data?.Base64Pdf)
    }

    function printPdf1(base64Data) {
      const contentType = "application/pdf";
      const blob = b64toBlob(base64Data, contentType);
      const blobUrl = URL.createObjectURL(blob);
    
      // Open PDF in a new tab
      const newTab = window.open(blobUrl, "_blank");
    
      // Optional: attempt to trigger print (may be blocked by some browsers)
      if (newTab) {
        newTab.onload = () => {
          newTab.print();
        };
      } else {
        alert("Popup blocked. Please allow popups for this site to view and print the PDF.");
      }
    }
    

    function b64toBlob(b64Data, contentType, sliceSize) {
      contentType = contentType || ""
      sliceSize = sliceSize || 512

      var byteCharacters = atob(b64Data)
      var byteArrays = []

      for (
        var offset = 0;
        offset < byteCharacters.length;
        offset += sliceSize
      ) {
        var slice = byteCharacters.slice(offset, offset + sliceSize)

        var byteNumbers = new Array(slice.length)
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i)
        }

        var byteArray = new Uint8Array(byteNumbers)

        byteArrays.push(byteArray)
      }

      var blob = new Blob(byteArrays, { type: contentType })
      return blob
    }
  }
  const sendEmailInBackground = (triggerDataLayer = false) => {
    if (!biApiData) {
      return
    }
    const payload = {
      journeyId: journeyState.journeyId,
      module: "BIEMAIL",
      applicationNumber: journeyState.applicationNo,
      TID: biApiData?.TransactionId || "",
    }
    const maxAttempts = 3
    const retryDelayMs = 3000

    const attemptSend = async (attempt) => {
      try {
        const res = await sendEmailBI(payload)
        console.log(res, "emailRes")
        if (res?.status) {
          successToastr(res.message)
          if (triggerDataLayer) {
            let formControlKey = "email"
            let journeyFormatData = props.applicationDataInJourneyFormat()
          }
          return
        }
        console.error(`sendEmailBI attempt ${attempt} failed:`, res?.message)
        if (attempt >= maxAttempts) {
          errorToastr("BI email could not be sent.")
        }
      } catch (err) {
        console.error(`sendEmailBI attempt ${attempt} failed:`, err)
        if (attempt >= maxAttempts) {
          errorToastr("BI email could not be sent.")
        }
      }
      if (attempt < maxAttempts) {
        await new Promise(resolve => setTimeout(resolve, retryDelayMs))
        await attemptSend(attempt + 1)
      }
    }

    attemptSend(1)
  }


  const sendEmail = async (callS3uploadPdf) => {
    if (!biApiData) {
      return
    }
    let payload = {
      journeyId: journeyState.journeyId,
      module: "BIEMAIL",
      applicationNumber: callS3uploadPdf ? journeyState.applicationNo : "",
      TID: biApiData?.TransactionId || "",
    }
    sendEmailBI(payload).then(res => {
      console.log(res, "emailRes")
      if (res?.status) {
        successToastr(res.message)
      } else {
        errorToastr(res.message)
      }
    })
  }

  //async function to make API call
  const getData = async () => {
    console.log("journeyState",journeyState.journeyId);
    let applicationDetailsPayload = {
      _id: journeyState.journeyId,
    }
    let applicationResult = await fetchApplicationDetails(
      applicationDetailsPayload
    )

    let payload = {
      journeyId: journeyState.journeyId,
      allRowData: true,
      productId: journeyState.productId
    }
    let journeyResult = await fetchAllJourneyData(payload)
    console.log("journeyresult",journeyResult);
    setAllJourneyData(journeyResult)
    if (journeyResult?.lifeAssuredDetails?.proceedWith) {
      setProceedWithOption(journeyResult?.lifeAssuredDetails?.proceedWith)
    }
    if(journeyResult?.journeyType?.toLowerCase() === "canarapos"){
      setPayNowOrLater("later")
    }
    generateBI(payload).then(async data => {
      console.log(journeyResult, data, "vjhdvhhs")
      setAllJourneyData(journeyResult)
      setJourneyState(prev => {
        return {
          ...prev,
          premium: Math.round(JSON.parse(data?.data?.BIJson)?.[0].MODAL_PREM_DISP) || 0,
          journeyData: applicationResult.applicationData,
        }
      })
      setBiApiData(data.data);
      pdfDownload({
        applicationNumber: journeyState.applicationNo,
        TID: data.data.TransactionId || "",
      })
        .then(pdfResult => {
          setPdfData(pdfResult.data.Base64Pdf);
        })
        .catch(error => {
          console.error("Error while downloading PDF:", error);
        });

      getTOFpaymentReceipt(journeyState.applicationNo)
      .then(res => {
        const receipts = res.data || [];
        const validReceipts = receipts.filter(receipt => lookup.validReceiptStatus[0].hasOwnProperty(receipt.receiptStatus));
        let sum = 0;
        validReceipts.forEach(receipt => {
          sum += parseInt(receipt.amount);
        });
        if (sum >= (Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX))) {
          setSkipPayment(true);
        }
        setJourneyState(prev => ({
          ...prev,
          receipts: validReceipts 
        }));
      })
      .catch(err => console.info(err));

    })
    .catch(err => {
      console.log("error in save application of save application and call BI function")
    })
  }

  const handleEnterPayoutOption = (event, value) => {
    console.log(event.key);
    if (event.key == 'Enter') {
      handlePayOption({ target: { value: value } })
    }

  }

  //Use Effects
  useEffect(async () => {
    console.log("getdata callaed");
    await getData();
    console.log("bidattttaaaa",biApiData);
  }, [])

  // useEffect(() => {
  //   storePdfData()
  // }, [biApiData])

  //Page Functions
  const handlePayOption = ({ target }) => {
    console.log(target.value, "value in BI");
    if (target.value === "now") {
      setPayNowOrLater("now")
      setIsPayBasba(false)
    } else if (target.value === "later") {
      setPayNowOrLater("later")
      setIsPayBasba(false)
    } else if (target.value === "basba") {
      setIsPayBasba(true)
    }
  }

  const handlePrevious = () => {
    try {
      const payload = {
        journeyId: journeyState.journeyId, 
        buttonClicked:  "Previous", 
      };
      updateUserTrackerDetails(payload)
        .then((response) => {
          if (response?.status) {
            console.log("UserTracker updated successfully:", response.message);
          } else {
            console.error("Error in updating UserTracker:", response?.message);
          }
        })
        .catch((error) => {
          console.error("Error in updateUserTrackerDetails API call:", error);
        })
    } catch (error) {
      console.error("Error in handlePrevious:", error);
    }
    if (proceedWithOption === "manually") {
      props.setCurrentSectionIndex(prev => prev - 1) // this moves to previous section on same page
      setJourneyState(prev => {
        return {
          ...prev,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    }
  }

  // code of tab enter
  const handleEnterPrevious = (event) => {
    if (event?.key == 'Enter') {
      handlePrevious();
    }
  }
  // code of tab enter
  const handleEnterDownload = (event) => {
    if (event?.key == 'Enter') {
      downloadPdf();
    }
  }
  // code of tab enter
  const handleEnterPrint = (event) => {
    if (event?.key == 'Enter') {
      printPdf();
    }
  }
  // code of tab enter
  const handleEnterEmail = (event) => {
    if (event?.key == 'Enter' && canSendBiEmail) {
      sendEmail(true);
    }
  }
  // code of tab enter
  const handleEnterRecalculate = (event) => {
    if (event?.key == 'Enter') {
      handleReCalculate();
    }
  }

  const handleProceedClick = (ev) => {
    ev.preventDefault()
    if (!isChecked) return
    contactConsentGate.requestProceed(ev, event => {
      if (skipPayment) {
        handleProceedSkipPayment(event)
      } else {
        handleProceed(event)
      }
    })
  }

  const handleProceed = async ev => {
    ev.preventDefault()
    if (!isChecked) {
      return;
    }
    console.log("tessttttttxxxxxxxxxxx",props);

    // downloadLinkOfPdf(pdfData);
    sendEmailInBackground();
    const ageBI=calculateAge(allJourneyData?.lifeAssuredDetails?.dob)

      let temp = journeyState.journeySteps

      setJourneyState(prev => {
        return {
          ...prev,
          journeySteps: temp,
          lastPage: props.currentPageIndex,
          lastSection: props.currentSectionIndex,
          premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
          lastPageCode: props.pageId,
          lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
          paymentStep: "L",
          journeyCode: findCurrentJourneyCode(
            props.pageId,
            props.sections[props.currentSectionIndex].sectionId
          ),
        }
      })
    console.log("journeystateee222222222222222e",journeyState);
    setSectionState(prev => {
      // making section data empty to load new sectionData
      return {
        ...prev,
        sectionId: null,
        sectionFirstPass: null,
        sectionData: {},
      }
    })
    let sendPayload = {
      applicationData: journeyState.journeyData,
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        lastPageCode: props.pageId,
        paymentStep: payNowOrLater === "now" ? "N" : "L",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        isBasbaAttempted: isPayBasba ? "Y" : "N",
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        planOption: journeyState.planOption,
        ageAtBI:ageBI,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
        },
        posDashboardListingData:{
          canaraPosCaseType: "sendCaseToCustomer"
        }
      // base64Data: pdfData,
    }
    saveApplication(sendPayload).then(res => {
      console.log(res, "application response")
      props.setCurrentSectionIndex(0)
      props.setCurrentPageIndex(prev => prev + 1)
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState({})
      setErrorState((prev) => {
        return ({
            ...prev,
            ["companyEIaLinked"]: ""
          })
      })
    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration")
    })
  }

  const handleProceedSkipPayment = (e) => {
    e.preventDefault();

    const temp = journeyState.journeySteps;

    let makePaymentPageIndex = temp.pages.findIndex(page => page.pageId === "makePayment");
    temp.pages[makePaymentPageIndex].sections = temp.pages[makePaymentPageIndex].sections.filter(section => section.sectionId === "eNach-physicalMandate")//show only e-nach section if skip payment
    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp
      }
    });

    let sendPayload = {
      applicationData: journeyState.journeyData,
      skipPayment:'Y',
      journeyData: {
        _id: journeyState.journeyId,
        lastPage: props.currentPageIndex + 1,
        lastSection: 0,
        applicationNo: journeyState.applicationNo,
        illustrationNumber: journeyState.illustrationNumber,
        proposalEntryId: journeyState.proposalEntryId,
        premium: (Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX)) || 0,
        lastPageCode: props.pageId,
        paymentStep: "N",
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        planOption: journeyState.planOption,
        canaraPosCaseType: allJourneyData?.journeyType?.toLowerCase() === "canarapos" ? "sendCaseToCustomer" : null
      },
    }

    saveApplication(sendPayload).then(async res => {
      console.log(res, "application response");
      props.setCurrentPageIndex(prev => prev + 1);
      setErrorState({});
      props.setCurrentSectionIndex(0); 

      // Save transaction details if skipPayment is true
      if (skipPayment) {
        const validReceipts = journeyState.receipts || [];
        const transactions = validReceipts.map(receipt => transformReceiptToTransaction(receipt, journeyState));

        const transactionPayload = {
          journeyId: journeyState.journeyId,
          applicationNumber: journeyState.applicationNo,
          status: 'Success',
          skipPayment: 'Y',
          transactions: transactions
        };

        let saveResp = await saveTransactionDetails(transactionPayload);
        console.log(saveResp, "saveTransactionDetails");
      }


    }).catch(err => {
      console.log(err, "err in saveApplication benefit-illustration");
    });
  }

  const handleReCalculate = () => {
      props.setCurrentPageIndex(0)
      props.setCurrentSectionIndex(0)

      try {
        const payload = {
          journeyId: journeyState?.journeyId, 
          buttonClicked: "ReCalculate", 
        };
        updateUserTrackerDetails(payload)
          .then((response) => {
            if (response?.status) {
              console.log("UserTracker updated successfully:", response.message);
            } else {
              console.error("Error in updating UserTracker:", response?.message);
            }
          })
          .catch((error) => {
            console.error("Error in updateUserTrackerDetails API call:", error);
          })
      } catch (error) {
        console.error("Error in handleReCalculate:", error);
      }

      const tempPage = journeyState.journeyData[0]
      setPageState(prev => {
        return {
          ...prev,
          pageId: tempPage.pageId,
          pageData: tempPage.pageData,
        }
      })
      const tempState = journeyState.journeyData[0].pageData[0]
      setSectionState(prev => {
        return {
          ...prev,
          sectionId: tempState.sectionId,
          sectionData: tempState.sectionData,
        }
      })
  }
  
  
  const handleSendLinkToSales = (ev) => {
    ev.preventDefault()
    if (!isChecked) {
      return;
    }
    sendEmail(true);
    console.log("tesstttttt",journeyState.journeySteps.pages);
    let temp = journeyState.journeySteps

    temp.pages = temp.pages.filter(page => page.pageId !== "PagePension4lifeFillProposalForm" && page.pageId !== "makePayment" && page.pageId !== "uploadDocuments")
    temp.pages.push(...lookup.sendLinktosales)
    if(allJourneyData?.productDetails?.premiumFrequency === "SG"){
      temp.pages = temp.pages.filter(page => page.pageId !== "makePayment")
    }
    console.log(temp.pages)

    setJourneyState(prev => {
      return {
        ...prev,
        journeySteps: temp,
        lastPage: props.currentPageIndex,
        lastSection: props.currentSectionIndex,
        premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
        lastPageCode: props.pageId,
        lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
        paymentStep: "L",
        journeyCode: findCurrentJourneyCode(
          props.pageId,
          props.sections[props.currentSectionIndex].sectionId
        ),
        canaraPosCaseType: "sendLinktosales"
      }
    })
  console.log("journeystateeee",journeyState);
  setSectionState(prev => {
    // making section data empty to load new sectionData
    return {
      ...prev,
      sectionId: null,
      sectionFirstPass: null,
      sectionData: {},
    }
  })
  // let optInPayload = {
  //   "mobileNo": allJourneyData.salesAgentDetails.mobileNo
  // }
  // let whatsAppOptres = whatsAppOptin(optInPayload)
  let sendPayload = {
    applicationData: journeyState.journeyData,
    journeyData: {
      _id: journeyState.journeyId,
      lastPage: props.currentPageIndex,
      lastSection: props.currentSectionIndex,
      applicationNo: journeyState.applicationNo,
      illustrationNumber: journeyState.illustrationNumber,
      proposalEntryId: journeyState.proposalEntryId,
      lastPageCode: props.pageId,
      paymentStep: payNowOrLater === "now" ? "N" : "L",
      lastSectionCode: props.sections[props.currentSectionIndex].sectionId,
      premium: biApiData && Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX),
      planOption: journeyState.planOption,
      canaraPosCaseType: "sendLinktosales"
    },
    posDashboardListingData:{
      canaraPosCaseType: "sendLinktosales"
    }
  }
  saveApplication(sendPayload).then(res => {
    console.log(res, "application response")
    successToastr('Application will be visible on sales Dashboard')
    props.setCurrentSectionIndex(0)
    props.setCurrentPageIndex(prev => prev + 1)
    setErrorState({})
    setErrorState({})
    setErrorState({})
    setErrorState({}) 
  }).catch(err => {
    console.log(err, "err in saveApplication benefit-illustration")
  })
  }


  let planDetails = [
    {
      q1: "Proposal No.",
      ans1: allJourneyData?.basicDetails.applicationNumber,
      q2: "UIN",
      ans2: "136N071V11",
    },
    {
      q1: "Name of the Plan",
      ans1: "Canara HSBC Life Insurance Pension4Life",
      q2: "Date of Quotation",
      ans2: allJourneyData?.basicDetails?.applicationNoGenerationTime ? moment.unix(allJourneyData?.basicDetails?.applicationNoGenerationTime).utcOffset("+05:30").format("DD/MMM/YYYY") : "NA",
    },
    {
      q1: "Premium Payment Term",
      ans1: "Single",
      q2: "Annuity option",
      ans2:getValueFromLookup("annuityOption", allJourneyData?.productDetails?.annuityOption)
    },
    {
      q1: "Annuity Installment Frequency",
      ans1: `${lineCapital(getValueFromLookup(
        "premiumFrequency",
        allJourneyData?.productDetails?.annuityInstFreq
      ) ?? '') || "NA"}`,
      q2: "Deferment Period",
      ans2:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[0].DEFERMENT_DISPLAY)) : "NA"}`,
    },
    {
      q1: "Annuity Commencement Date",
      ans1: `${biApiData ? ((JSON.parse(biApiData.BIJson)?.[0].ANNUITY_COMM_DATE)) : "NA"}`,
      q2: "Maturity Benefit",
      ans2: "NA",
    },
    {
      q1: "Loan",
      ans1: "NA",
      q2: "",
      ans2: "",
    },
  ]
  let planBenifits = [
    {
      year:"1",
      gdb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[0].DB_G)) : "NA"}`,
      gsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[0].GSV)) : "NA"}`,
      nongsb: `${biApiData ? ((JSON.parse(biApiData.BIJson)?.[0].SV)) : "NA"}`,
    },
    {
      year:"2",
      gdb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[1].DB_G)) : "NA"}`,
      gsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[1].GSV)) : "NA"}`,
      nongsb: `${biApiData ? ((JSON.parse(biApiData.BIJson)?.[1].SV)) : "NA"}`,
    },
    {
      year:"3",
      gdb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[2].DB_G)) : "NA"}`,
      gsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[2].GSV)) : "NA"}`,
      nongsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[2].SV)) : "NA"}`,
    },
    {
      year:"4",
      gdb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[3].DB_G)) : "NA"}`,
      gsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[3].GSV)) : "NA"}`,
      nongsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[3].SV)) : "NA"}`,
    },
    {
      year:"5",
      gdb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[4].DB_G)) : "NA"}`,
      gsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[4].GSV)) : "NA"}`,
      nongsb: `${biApiData ? ((JSON.parse(biApiData.BIJson)?.[4].SV)) : "NA"}`,
    },
    {
      year:"6",
      gdb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[5].DB_G)) : "NA"}`,
      gsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[5].GSV)) : "NA"}`,
      nongsb: `${biApiData ? ((JSON.parse(biApiData.BIJson)?.[5].SV)) : "NA"}`,
    },
    {
      year:"7",
      gdb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[6].DB_G)) : "NA"}`,
      gsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[6].GSV)) : "NA"}`,
      nongsb: `${biApiData ? ((JSON.parse(biApiData.BIJson)?.[6].SV)) : "NA"}`,
    },
    {
      year:"8",
      gdb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[7].DB_G)) : "NA"}`,
      gsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[7].GSV)) : "NA"}`,
      nongsb: `${biApiData ? ((JSON.parse(biApiData.BIJson)?.[7].SV)) : "NA"}`,
    },
    {
      year:"9",
      gdb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[8].DB_G)) : "NA"}`,
      gsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[8].GSV)) : "NA"}`,
      nongsb: `${biApiData ? ((JSON.parse(biApiData.BIJson)?.[8].SV)) : "NA"}`,
    },
    {
      year:"10",
      gdb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[9].DB_G)) : "NA"}`,
      gsb:`${biApiData ? ((JSON.parse(biApiData.BIJson)?.[9].GSV)) : "NA"}`,
      nongsb: `${biApiData ? ((JSON.parse(biApiData.BIJson)?.[9].SV)) : "NA"}`,
    },
  ]
  let annuityDetails = [
    {
      q1: "Purchase Price (Single Premium)",
      ans1: `₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM)) : "NA"}`,
      q2: "Goods and Services Tax & applicable cess (es)/other levy, if any)",
      ans2: `₹${biApiData ? Number(JSON.parse(biApiData.BIJson)?.[0].TAX_DISPLAY) ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].TAX_DISPLAY)) : "0" : "0"}`,
    },
    {
      q1:
        "Total amount payable (Purchase Price + Goods and Services Tax & applicable cess (es)/other levy, if any)",
      ans1: `₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX)) : "NA"}`,
      q2: "Annuity Installment (as per chosen frequency)",
      ans2:`₹${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_ANNUITY)) : "NA"}`
    },
  ]

  return (
    <>
      <style>
        {`

          .option-buit-design-new-new-design::after{
            height: 2rem
          }
          .shadow-box-card{
            background-color: #fff;
            box-shadow: 0px 0px 10px #ccc;
            border-radius: 10px;
            padding: 0px 0px;
            float: left;
            width: 100%;
            margin-bottom: 30px;
            height: 172px;
          }
          .option-buit-design-new-structure-sec1 .checkmark, .option-buit-design-new-structure-sec2 .checkmark, .option-buit-design-new-structure-sec3 .checkmark, .option-buit-design-new-structure-sec4 .checkmark {
            background-color: #ededed;
            left: 0px;
            top: 0px;
          }
          radio-line{
            width: 100%;
            height: 100%
          }
          .customradio{
            padding: 22px 0px
          }
          .customradio .checkmark {
            top: 22px !important;
          }
          .by-pay{
            bottom: 8px
          }
          resent-bi-center{
            position: relative;
          }
          .eky-resend {
            margin: auto;
            right: 25px;
            position: relative;
            left: 4px
          }
          .custom-otp{
            margin: auto
          }
          .table-design .table-bg .border-right td:nth-child(2){
            border-right:1px solid;
          }
          .table-design .table-bg .border-right-fund td:nth-child(3){
            border-right:1px solid;
          }
         
        `}
      </style>
      {allJourneyData && biApiData && (<div className="container">
        {/*left-side*/}
        <form
          id="declaration-form"
          name="declaration-form"
          action
          method="post"
          autoComplete="off"
          noValidate="novalidate"
        >
          <div className="iselect-padding mt-20">
            <div className="iselect-box-design mb">
              <div className="heading-design">
                <div className="iselect-padding left-side-head">
                  <h1 className="iselect-heading">Benefit Illustration</h1>
                  <span className="subhead">
                  Canara HSBC Life Insurance Pension4Life Plan &nbsp; | &nbsp; UIN:
                  136N071V11{" "}
                  </span>{" "}
                </div>
                <div className="app-quatation mt hidden-desktop-screen">
                  <div className="application-design-number">
                    Application Number: {journeyState.applicationNo}
                  </div>
                </div>
              </div>
              <div className="bi-summary">
                <div className="auther-description mt-20">
                  <h3>
                  Dear{" "}
                  {allJourneyData?.journeyType == "CanaraPos" ?
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.title === "MR" ? 'Mr. ' :  allJourneyData?.lifeAssuredDetails?.title === "MS" ?  'Ms. ' : allJourneyData?.lifeAssuredDetails?.title === "MRS" ?  'Mrs. '
                          : ''
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      :
                      <b>
                        { allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? allJourneyData?.proposerDetails?.gender.toUpperCase() == "M" || allJourneyData?.proposerDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `
                          : (allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "M" || allJourneyData?.lifeAssuredDetails?.gender.toUpperCase() == "T" ? `Mr. ` : `Ms. `)
                        }
                        {allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? (wordCapital(allJourneyData?.proposerDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.proposerDetails?.lastName)) :wordCapital(allJourneyData?.lifeAssuredDetails?.fullName ?? '')}
                      </b>
                      }
                      {" "}      
                  </h3>
                  <p className="benefit-title">
                  Thank you for interest in our Canara HSBC Life Insurance Pension4life Plan. Based on the details provided by you, and reproduced below, the quotation to your requirements is appended.
                  </p>
                  
                </div>
              </div>
              <div className="Bi-design-structure-table mt-50 iselect-mg-bottom">
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table headline-table headline-table headline-table1">
                      Personal Details of Primary & Secondary Annuitant
                    </h2>
                    <div className="table-bg">
                      <table className="table border-right personal-details-style">
                        <thead>
                          <tr align="center" className="table-color"> <th colSpan="4" style={{border:"none"}}>Details Of Primary Annuitant</th></tr>
                        </thead>
                        <tbody class="">
                          <tr className="table-color-grey">
                            <td width="25%">Name Of Primary Annuitant</td>
                            <td width="25%" align="right"> {`${wordCapital(allJourneyData?.lifeAssuredDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.lifeAssuredDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.lifeAssuredDetails?.lastName)}`}</td>
                            <td width="25%"> Date Of Birth</td>
                            <td width="25%" align="right">{allJourneyData?.lifeAssuredDetails?.dob ? maskInFormat(allJourneyData?.lifeAssuredDetails?.dob * 1000) : "NA"}</td>
                          </tr>
                          <tr className="table-color">
                            <td width="25%">Age</td>
                            <td width="25%" align="right">{biApiData ? JSON.parse(biApiData.BIJson)?.[0]?.LI_ATTAINED_AGE : ""}</td>
                            <td width="25%"> Gender</td>
                            <td width="25%" align="right">{getValueFromLookup("gender",allJourneyData?.lifeAssuredDetails?.gender) || "NA"}</td>
                          </tr>
                        </tbody>
                        <thead>
                          <tr align="center"> <th colSpan="4" style={{border:"none"}}>Details Of Secondary Annuitant</th></tr>
                        </thead>
                        <tbody>
                          <tr className="table-color">
                            <td>Name Of Secondary Annuitant</td>
                            <td align="right"> {allJourneyData?.productDetails?.annuityOption === "Q" ? allJourneyData?.spouseDetails?.firstName ? `${wordCapital(allJourneyData?.spouseDetails?.firstName ?? '') + " " + wordCapital(allJourneyData?.spouseDetails?.middleName ?? '') + " " + wordCapital(allJourneyData?.spouseDetails?.lastName)}` : "NA" : "NA"}</td>
                            <td> Date Of Birth</td>
                            <td align="right">{allJourneyData?.productDetails?.annuityOption === "Q" ? allJourneyData?.spouseDetails?.dob ? maskInFormat(allJourneyData?.spouseDetails?.dob * 1000) : "NA" : "NA"}</td>
                          </tr>
                          <tr className="table-color-grey">
                            <td>Age</td>
                            <td align="right">{allJourneyData?.productDetails?.annuityOption === "Q" ? allJourneyData?.spouseDetails?.dob ? getAge(allJourneyData?.spouseDetails?.dob) : "NA" : "NA"}</td>
                            <td> Gender</td>
                            <td align="right">{allJourneyData?.productDetails?.annuityOption === "Q" ? allJourneyData?.spouseDetails?.gender ? getValueFromLookup("gender",allJourneyData?.spouseDetails?.gender) : "NA" : "NA"}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table headline-table headline-table1">Plan Details</h2>
                    <div className="table-bg">
                      <table className="table border-right personal-details-style">
                        <tbody>
                          {planDetails.map((elem, index) => {
                            return (
                              <tr
                                className={`table-color${
                                  index % 2 !== 0 ? "-grey" : ""
                                }`}
                              >
                                <td width="33%">{elem.q1}</td>
                                <td
                                  width="17%"
                                  align="right"
                                  className="rd-tatav"
                                >
                                  {elem.ans1}
                                </td>
                                <td width="26%" align="left">
                                  {elem.q2}
                                </td>
                                <td width="24%" align="right">
                                  {elem.ans2}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <div className="table-bg" style={{border:"none"}}>
                      <table className="table border-right-fund">
                        <thead
                          className="headline-table headline-table headline-table1"
                          style={{height:"50px",fontSize:""}}
                        >
                          <th style={{ paddingBottom:"13px"}}>
                          End of Policy Year
                          </th>
                          <th style={{ paddingBottom:"13px"}}>Guaranteed Death Benefit</th>
                          <th style={{ paddingBottom:"13px"}}>Guaranteed Surrender Benefit</th>
                          <th style={{paddingLeft: "10px", paddingBottom:"13px" }}>
                          Non - Guaranteed Surrender Benefit
                          </th>
                        </thead>
                        <tbody>
                        {planBenifits.map((elem,idx) => {
                          return (
                            <tr className={`table-color${idx % 2 !== 0 ? "-grey" : ""}`}>
                              <td align="center">{elem.year}</td>
                              <td align="center">{elem.gdb}</td>
                              <td align="center" style={{borderRight:"none"}}>{elem.gsb}</td>
                              <td align="center">{elem.nongsb}</td>
                            </tr>
                          )
                        })}
                          
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div className="clearfix" />
                <div className="col-md-12">
                  <div className="table-responsive table-design laesf">
                    <h2 className="headline-table headline-table headline-table1">
                      Purchase Price & Annuity Details
                    </h2>
                    <div className="table-bg">
                      <table className="table border-right personal-details-style">
                        <tbody>
                          {annuityDetails.map((elem, index) => {
                            return (
                              <tr
                                className={`table-color${
                                  index % 2 == 0 ? "-grey" : ""
                                }`}
                              >
                                <td width="33%">{elem.q1}</td>
                                <td
                                  width="17%"
                                  align="right"
                                  className="rd-tatav"
                                >
                                  {elem.ans1}
                                </td>
                                <td width="26%" align="left">
                                  {elem.q2}
                                </td>
                                <td width="24%" align="right">
                                  {elem.ans2}
                                </td>
                              </tr>
                            )
                          })}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="clearfix" />
              <div className="transactionDetailsWrap">
                <div className="detailContentWrap">
                  <div className="row">
                    <div className="buttonWrap">
                      <div
                        className="button submit-btn"
                        style={{ cursor: "pointer" }}
                        tabIndex="0"
                        onKeyPress={(e) => handleEnterDownload(e)}
                        onClick={downloadPdf}
                      >
                        <a> Download</a>
                      </div>
                      <div
                        className="button submit-btn"
                        style={{ cursor: "pointer" }}
                        tabIndex='0'
                        onKeyPress={(e) => handleEnterPrint(e)}
                        onClick={printPdf}
                      >
                        <a> Print</a>
                      </div>
                      <div
                        className={
                          canSendBiEmail ? "button submit-btn" : "button manually-submit-btn"
                        }
                        style={{
                          cursor: canSendBiEmail ? "pointer" : "not-allowed",
                          ...disabledEmailButtonStyle,
                        }}
                        tabIndex={canSendBiEmail ? "0" : "-1"}
                        aria-disabled={!canSendBiEmail}
                        title={canSendBiEmail ? "Send BI on email" : "Enter email to enable this button"}
                        onKeyPress={(e) => handleEnterEmail(e)}
                        onClick={() => {
                          if (canSendBiEmail) {
                            sendEmail(true)
                          }
                        }}
                      >
                        <a style={emailAnchorStyle}>
                          {!canSendBiEmail && <FaLock size={12} />}
                          Email
                        </a>
                      </div>
                      <div
                        className="button submit-btn"
                        style={{
                          cursor: "default",
                        }}
                        tabIndex="0"
                        onKeyPress={(e) => handleEnterRecalculate(e)}
                        onClick={handleReCalculate}
                      
                      >
                        <a>Re-Calculate</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="option-buit-design-new-structure Bi-page-pay-structure mt-30">
                <div className="col-md-12">
                  <div className="option-buit-design-new-structure-box">
        
                    {skipPayment && <p style={{
                    textAlign : "center",
                    fontSize : "18px",
                    marginTop : "30px"

                  }}>Premium of Rs {`${biApiData ? applyComma(Math.round(JSON.parse(biApiData.BIJson)?.[0].MODAL_PREM_TAX)) : "NA"}`} is adjusted against transfer of funds from old application</p>}
                  </div>
                </div>
              </div>
              <div className="clearfix" />
              <div className="iselect-mg-bottom mt-50 medical-btn hidden-desktop-screen">
                <div className="col-md-12">
                  <div className="but-center text-center">
                  {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div className="submit-btn cen"> <a aria-hidden="true" onClick={handlePrevious}> PREVIOUS </a> </div>
                    }
                    <input onClick={handleProceedClick}
                      className="previous-btn cen text-uppercase ls2"
                      style={{
                        color: "white",
                        padding: "14px 40px",
                        border: "none",
                      }}
                      type="submit"
                      value="PROCEED"
                    />
                    {allJourneyData?.journeyType === "CanaraPos" &&
                      <span>
                    <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to  Sales"  onClick={handleSendLinkToSales} />
                    {/* <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} /> */}
                      </span>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
        {/*left-side*/}
        <div className="iselect-mg-bottom">
          <div className="col-md-12 pl-pr">
            <div className="discloser iselect-box-design">
              <h2>Disclosures :</h2>
              <ul style={{listStyle:"disc"}}>
                <li>
                The Annuity Installment given above is only indicative. In case of any change in the annuity rates or change in the entry age of the Annuitant(s) before issuance of the Policy, a revised quotation is to be signed and submitted.

                </li>
                <li>
                Upon the payment of Death Benefit/ Surrender Benefit / CI Benefit / ATPD Benefit, the Policy terminates and no further benefit becomes payable.
                </li>
                <li>Surrender Benefits are shown at the end of the Policy Year. Further, depending on the prevailing market conditions, the Non-Guaranteed Surrender may be revised.
                </li>
                <li>Depending upon the Annuity Option chosen, Surrender Benefit which is higher of Guaranteed Surrender Benefit and Non - Guaranteed Surrender Benefit will be payable.
                </li>

                <li>
                Once the Policy is issued, the Annuity Installment payable is guaranteed for life.</li>
                <li>The Annuity Installment is inclusive of High Purchase Price Incentive (as applicable) and Boosters (as applicable).</li>
                <li>Goods and Services Tax including applicable cess(es)/other levy, if any will be charged on the Purchase Price as per the prevailing tax laws.</li>
                <li>Tax benefits under this plan are as per the prevailing tax laws which are subject to amendments from time to time. Please contact your independent tax advisor for details.</li>
                <li>Issuance of the Policy and acceptance of the Proposal is completely at the discretion of Canara HSBC Life insurance Company Limited (“Company”) and this illustration would in no way tantamount to acceptance of risk by the Company.</li>
                <li>For more details on risk factors, terms and conditions, please read the sales brochure carefully before concluding the sale.</li>

                
              </ul>
</div>
          </div>
        </div>
        {/* <!--mobile view button--> */}
        <div className="mobile-view-btn-Q1 pd-mobile-space-structure button1 canara-pos-bi-btn">
          <div className="iselect-mg-bottom">
            <div className="col-md-12">
              <div className="but-center text-center">
              {
                    allJourneyData?.lifeAssuredDetails?.isLaAndPropSame === "N" ? 
                    (allJourneyData?.proposerDetails?.kycVerified || allJourneyData?.proposerDetails?.ckycVerified || allJourneyData?.proposerDetails?.matchTypeDedupe) &&
                    <div
                        className="submit-btn cen"
                        style={{ marginRight: "5px" }}
                        >
                        {" "}
                        <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                        </div>
                    :
                      (allJourneyData?.lifeAssuredDetails?.kycVerified || allJourneyData?.lifeAssuredDetails?.ckycVerified || allJourneyData?.lifeAssuredDetails?.matchTypeDedupe) &&
                      <div
                          className="submit-btn cen"
                          style={{ marginRight: "5px" }}
                          >
                          {" "}
                          <a aria-hidden="true" onClick={handlePrevious}>Previous</a>{" "}
                          </div>
                    }
                <div className="previous-btn cen">
                  <a>
                    {" "}
                    <button
                      type="submit"
                      value="button1"
                      style={{
                        backgroundColor: "transparent",
                        border: "none",
                        color: "#fff",
                      }}
                      onClick={handleProceedClick}
                    >
                      Proceed
                    </button>{" "}
                  </a>
                </div>
                  {allJourneyData?.journeyType === "CanaraPos" &&
                  <div className="previous-btn cen send-link-to-cust">
                      <span>
                        <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Link to Sales"  onClick={handleSendLinkToSales} />
                      </span>
                  </div>
                  }
                {/* <div className="previous-btn cen send-link-to-cust">
                  {allJourneyData?.journeyType === "CanaraPos" &&
                    <span>
                      <input className="previous-btn cen ls2" style={{ color: "white", padding: "14px 40px", border: "none" }} type="submit" value="Send Case to Sales"  onClick={handleSendLinkToSales} />
                    </span>
                  }
                </div> */}
              </div>
            </div>
          </div>
        </div>
        {/* <!--mobile view button-->  */}
        <div className="clearfix"></div>
      </div>)}
      <ContactConsentModal
        show={contactConsentGate.showModal}
        initialValues={contactConsentGate.initialValues}
        onClose={contactConsentGate.handleModalClose}
        onProceed={contactConsentGate.handleModalProceed}
        channel={props.channel}
        lookup={journeyState.lookup}
      />
    </>
  )
}
